import React from 'react';
import { withTranslation } from 'react-i18next';

import { getAudioStreams } from '../models/audio';
import Loader from './snippets/loader';
import { Alert } from 'reactstrap';
import { UncontrolledDropdown, DropdownMenu, DropdownToggle, DropdownItem } from 'reactstrap';
import Slider from '@material-ui/core/Slider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class RoomAudioTest extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isLoadedStreams: false,
      streams: null,
      volume: 50,
      error: null,
    }

    this.handleChangeStream = this.handleChangeStream.bind(this);
    this.handleChangeVolume = this.handleChangeVolume.bind(this);
    this.handleMusic = this.handleMusic.bind(this);
  }

  componentDidMount() {
    this.retrieveAudioStreams();
  }

  componentWillUnmount() {
    if(this.roomMusic){
      this.roomMusic.pause();
    }
  }

  retrieveAudioStreams() {
    getAudioStreams()
      .then(result => {
        let streams = result;
        this.setState({
          streams,
          activeStream: streams[0],
          isLoadedStreams: true,
        })
        this.handleMusic(streams[0].streamUrl,this.state.volume);
      }, error => {
        this.setState({error});
      });
  }

  handleChangeStream(stream) {
    this.setState({activeStream: stream},()=>this.handleMusic(stream.streamUrl, this.state.volume));
  }

  handleChangeVolume(volume) {
    this.setState({volume});
    this.volumeDebounceTimer = setTimeout((e) => {
      this.handleMusic(this.state.activeStream.streamUrl,this.state.volume, true);
    }, 300);
  }

  handleMusic(link,volume,updateVolume) {
    if(!updateVolume){
      if(this.roomMusic){
        if(link){
          this.roomMusic.src = link;
          this.roomMusic.play();
        }
      } else{
        this.roomMusic = new Audio(link);
        this.roomMusic.volume = volume?volume*.01:0;
        this.roomMusic.play();
      }
    } else if(this.roomMusic && Number.isInteger(volume)){
      this.roomMusic.volume = volume*.01;
    }
  }
  
  render() {
    const { t } = this.props;
    const { isLoadedStreams, streams, activeStream, volume, error } = this.state;
    return (
      <div className="reception-view">
        <div className="">
          {isLoadedStreams?
            <div className="row">
              <div className="col-12">
                <table className="table">
                  <thead>
                    <tr>
                      <th width="40%">{t("Stream")}</th>
                      <th width="30%">{t("Volume")}</th>
                    </tr>
                  </thead>
                  <tbody>
                     <tr>
                        <td>
                          <UncontrolledDropdown>
                            <DropdownToggle caret={true} className="btn-block">
                              {activeStream.name}
                            </DropdownToggle>
                            <DropdownMenu>
                              {streams.map((stream,i) => {
                                return <DropdownItem key={i} className={activeStream.id===stream.id?"active":""} onClick={() => this.handleChangeStream(stream)}>{t(stream.name)}</DropdownItem>
                              })}
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </td>
                        <td>
                          <div className="d-flex align-items-center">
                            <FontAwesomeIcon className="mie-1" icon="volume-up" />
                            <div className="mie-3">{volume}</div>
                            <Slider
                              value={volume}
                              steps={10}
                              valueLabelDisplay="auto"
                              onChange={(e,value) => this.handleChangeVolume(value)}
                            />
                          </div>                          
                        </td>
                      </tr>
                  </tbody>
                </table>
              </div>
            </div>
          : (error ?
            <Alert color="danger">{t(error)} <span className="alert-link mis-2" onClick={()=>window.location.reload()}>{t("Try again")}</span></Alert>
          : <Loader />)}
        </div>
      </div>
    )
  }
}
export default withTranslation()(RoomAudioTest);